import { render, staticRenderFns } from "./ForwardChatbotTunings.vue?vue&type=template&id=2b201da3&scoped=true"
import script from "./ForwardChatbotTunings.vue?vue&type=script&lang=js"
export * from "./ForwardChatbotTunings.vue?vue&type=script&lang=js"
import style0 from "./ForwardChatbotTunings.vue?vue&type=style&index=0&id=2b201da3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b201da3",
  null
  
)

export default component.exports